import {
	FormControlLabel,
	FormGroup,
	Input,
	InputBase,
	makeStyles,
	Switch,
	Tab,
	Tabs,
	TextField,
	withStyles,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import './Finances.css';
import dayjs from 'dayjs';
import Modal from '../../layout/modal/Modal';
import DatePicker from 'react-datepicker';
import clsx from 'clsx';
import Calendar from 'react-calendar';

function Finances({
	irrevocableDate,
	mortgageDetails,
	setMortgageDetails,
	setIsCompleted,
	isCompleted,
	elevationList,
	elevationPrice,
	lotPrice,
	upgradeTotalPrice,
	setDisable,
	disable,
	setDisplayFinal,
	displayFinal,
}) {
	const [value, setValue] = useState(1);
	const [showCalendar, setShowCalendar] = useState(false);

	const totalCost =
		+elevationList[0]?.buildingPrice +
		+elevationPrice +
		+lotPrice +
		+upgradeTotalPrice?.cabinetry +
		+upgradeTotalPrice?.countertops +
		+upgradeTotalPrice?.doorstrim +
		+upgradeTotalPrice?.flooring +
		+upgradeTotalPrice?.lighting +
		+upgradeTotalPrice?.plumbing;

	const [downpaymentSchedule, setDownpaymentSchedule] = useState([]);

	const [firstInstallmentDate, setfirstInstallmentDate] = useState('');
	const [firstInstallmentCost, setfirstInstallmentCost] = useState('');

	const [secondInstallmentDate, setSecondInstallmentDate] = useState('');
	const [secondInstallmentCost, setSecondInstallmentCost] = useState('');

	const [thirdInstallmentDate, setThirdInstallmentDate] = useState('');
	const [thirdInstallmentCost, setThirdInstallmentCost] = useState('');

	const [forthInstallmentDate, setForthInstallmentDate] = useState('');
	const [forthInstallmentCost, setForthInstallmentCost] = useState('');

	const [fifthInstallmentDate, setFifthInstallmentDate] = useState('');
	const [fifthInstallmentCost, setFifthInstallmentCost] = useState('');

	const [sixthInstallmentDate, setSixthInstallmentDate] = useState('');
	const [sixthInstallmentCost, setSixthInstallmentCost] = useState('');

	// Modal
	const [firstInstallmentDateModal, setFirstInstallmentDateModal] =
		useState('');
	const [firstInstallmentCostModal, setFirstInstallmentCostModal] =
		useState('');

	const [secondInstallmentDateModal, setSecondInstallmentDateModal] =
		useState('');
	const [secondInstallmentCostModal, setSecondInstallmentCostModal] =
		useState('');

	const [thirdInstallmentDateModal, setThirdInstallmentDateModal] =
		useState('');
	const [thirdInstallmentCostModal, setThirdInstallmentCostModal] =
		useState('');

	const [approvalDate, setApprovalDate] = useState(new Date());

	const handleSaveInstallment = () => {
		setShow(false);
		setfirstInstallmentDate(
			dayjs(firstInstallmentDateModal).format('DD MMM YYYY')
		);
		setfirstInstallmentCost(firstInstallmentCostModal);

		setSecondInstallmentDate(
			dayjs(secondInstallmentDateModal).format('DD MMM YYYY')
		);
		setSecondInstallmentCost(secondInstallmentCostModal);

		setThirdInstallmentDate(
			dayjs(thirdInstallmentDateModal).format('DD MMM YYYY')
		);
		setThirdInstallmentCost(thirdInstallmentCostModal);
	};

	const [show, setShow] = useState(false);

	const [formData, setFormData] = useState({
		lendingInstitution: '',
		agentName: '',
		mortgageValue: '',
	});

	const { lendingInstitution, agentName, mortgageValue } = formData;

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const MortgageSwitch = withStyles((theme) => ({
		root: {
			width: 42,
			height: 26,
			padding: 0,
			margin: '0 21px',
		},
		switchBase: {
			padding: 1,
			'&$checked': {
				transform: 'translateX(16px)',
				color: theme.palette.common.white,
				'& + $track': {
					backgroundColor: '#52d869',
					opacity: 1,
					border: 'none',
				},
			},
			'&$focusVisible $thumb': {
				color: '#52d869',
				border: '6px solid #fff',
			},
		},
		thumb: {
			width: 24,
			height: 24,
		},
		track: {
			borderRadius: 26 / 2,
			border: `1px solid ${theme.palette.grey[400]}`,
			backgroundColor: theme.palette.grey[50],
			opacity: 1,
			transition: theme.transitions.create(['background-color', 'border']),
		},
		checked: {},
		focusVisible: {},
	}))(({ classes, ...props }) => {
		return (
			<Switch
				focusVisibleClassName={classes.focusVisible}
				disableRipple
				classes={{
					root: classes.root,
					switchBase: classes.switchBase,
					thumb: classes.thumb,
					track: classes.track,
					checked: classes.checked,
				}}
				{...props}
			/>
		);
	});

	const useStyles = makeStyles((theme) => ({
		root: {
			flexGrow: 1,
			borderRadius: 8,
		},
		form: {
			display: 'flex',
			flexDirection: 'column',
		},
		field: {
			marginBottom: '20px',
			margin: '20px',
			'& .MuiInput-underline:after': {
				borderBottomColor: 'blue',
				borderBottom: '2px solid',
			},
			width: '41em',
		},
		datePicker: {
			height: '36px',
			borderTop: 'none',
			borderLeft: 'none',
			borderRight: 'none',
			width: '41em',
			outline: 'none',
			borderBottom: '1px solid #949494 !important',
			marginTop: '30px',
			borderRadius: '0',
		},
		label: {
			marginBottom: '-2.3em',
			fontSize: '10px',
			color: 'grey',
		},
		installmentDate: {
			width: '25em',
		},
		financeTab: {
			backgroundColor: '#F1F5F8',
			marginBottom: '1em',
			boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
			width: '22em',
			borderRadius: '8px',
		},
	}));

	const StyledTabs = withStyles({
		indicator: {
			display: 'flex',
			justifyContent: 'center',
			backgroundColor: 'transparent',
		},
	})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

	const StyledTab = withStyles((theme) => ({
		root: {
			textTransform: 'none',
			color: '#636D73',
			borderRadius: '8px',

			'&.Mui-selected': {
				backgroundColor: '#FFFFFF',
				boxShadow: '0px 1px 8px rgba(20, 46, 110, 0.1)',
				borderRadius: '8px',
				color: '#2662F0',
			},
		},
	}))((props) => <Tab {...props} />);

	const styles = useStyles();

	const handleChange = (event, newValue) => {
		if (newValue === 1) {
			setMortgageDetails();
			setDisable({ ...disable, finances: false });
		} else if (newValue === 0) {
			setIsCompleted({ ...isCompleted, finances: false });

			setDisable({ ...disable, finances: true });
		}
		setValue(newValue);
	};

	useEffect(() => {
		var special = [
			'zeroth',
			'first',
			'second',
			'third',
			'fourth',
			'fifth',
			'sixth',
			'seventh',
			'eighth',
			'ninth',
			'tenth',
			'eleventh',
			'twelfth',
			'thirteenth',
			'fourteenth',
			'fifteenth',
			'sixteenth',
			'seventeenth',
			'eighteenth',
			'nineteenth',
		];
		var deca = [
			'twent',
			'thirt',
			'fort',
			'fift',
			'sixt',
			'sevent',
			'eight',
			'ninet',
		];

		var schedule = [];

		function capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		}

		function stringifyNumber(n) {
			if (n < 20) return special[n];
			if (n % 10 === 0) return deca[Math.floor(n / 10) - 2] + 'ieth';
			return deca[Math.floor(n / 10) - 2] + 'y-' + special[n % 10];
		}

		const irrDate = new Date();

		console.log('Date: ' + irrevocableDate);

		function numberWithCommas(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		}

		// var installment = numberWithCommas(((totalCost * 1.1) / 3).toFixed(2));
		var installment = numberWithCommas(25000);

		// for (var i = 1; i < 4; i++) {
		// 	var numberString = stringifyNumber(i);

		// 	const date = irrDate.setDate(irrDate.getDate() + 30);

		// 	var scheduleDetails = {
		// 		numberString: capitalizeFirstLetter(numberString),
		// 		date: dayjs(date).format('DD MMM YYYY'),
		// 		installment: installment,
		// 	};
		// 	schedule.push(scheduleDetails);
		// }

		// console.log(schedule);

		// setDownpaymentSchedule(schedule);

		const realFirstDate = Date.now();

		//dayjs(closing_date).unix() * 1000 + 86400000 * 120
		const firstDate = dayjs(irrDate).format('DD MMM YYYY');

		console.log('firstDate ' + firstDate);
		setfirstInstallmentDate(firstDate);
		setfirstInstallmentCost(installment);
		//irrDate.setDate(realFirstDate + ( 45 * 36000))
		const secondDate = dayjs(
			dayjs(realFirstDate).unix() * 1000 + 86400000 * 45
		).format('DD MMM YYYY');
		console.log('secondDate ' + secondDate);
		setSecondInstallmentDate(secondDate);
		setSecondInstallmentCost(25000);

		const thirdDate = dayjs(
			dayjs(realFirstDate).unix() * 1000 + 86400000 * 90
		).format('DD MMM YYYY');
		console.log('thirdDate ' + thirdDate);
		setThirdInstallmentDate(thirdDate);
		setThirdInstallmentCost(25000);

		const forthDate = dayjs(
			dayjs(realFirstDate).unix() * 1000 + 86400000 * 120
		).format('DD MMM YYYY');
		console.log('thirdDate ' + forthDate);
		setForthInstallmentDate(forthDate);
		setForthInstallmentCost(25000);

		const fifthDate = dayjs(
			dayjs(realFirstDate).unix() * 1000 + 86400000 * 180
		).format('DD MMM YYYY');
		console.log('thirdDate ' + fifthDate);
		setFifthInstallmentDate(fifthDate);
		setFifthInstallmentCost(40000);

		const sixthDate = dayjs(
			dayjs(realFirstDate).unix() * 1000 + 86400000 * 365
		).format('DD MMM YYYY');
		console.log('thirdDate ' + sixthDate);
		setSixthInstallmentDate(sixthDate);
		setSixthInstallmentCost(40000);
	}, []);

	function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}

	useEffect(() => {
		console.log('mortgageDetails', mortgageDetails);
		if (value === 1) {
			setIsCompleted({ ...isCompleted, finances: true });
			setDisplayFinal({ ...displayFinal, finances: true });
			setDisable({ ...disable, finances: false });
			setMortgageDetails();
		}
	}, [value]);

	const handleSave = () => {
		setIsCompleted({ ...isCompleted, finances: true });
		setDisable({ ...disable, finances: false });
		setMortgageDetails({
			institutionName: lendingInstitution,
			totalDownpayment: mortgageValue,
		});
	};

	const closeModalHandler = () => setShow(false);

	return (
		<div className='doc_card finances_wrapper'>
			<div className='card_title'>
				Is the client pre-approved for a mortgage?
			</div>
			<div className={styles.financeTab}>
				<div className={styles.clientTab}>
					<StyledTabs value={value} onChange={handleChange} centered>
						<StyledTab label={'Yes'} />
						<StyledTab label={'No'} />
					</StyledTabs>
				</div>
			</div>
			<div className={styles.root}>
				{value === 0 ? (
					<div className='mortgage_form'>
						<TextField
							type='text'
							label='Lending Institution'
							name='lendingInstitution'
							value={lendingInstitution}
							className={styles.field}
							onChange={(e) => onChange(e)}
						/>
						<TextField
							type='text'
							label='Name of mortgage agent'
							name='agentName'
							value={agentName}
							className={styles.field}
							onChange={(e) => onChange(e)}
						/>
						<TextField
							type='number'
							label='Mortgage Value'
							name='mortgageValue'
							value={mortgageValue}
							className={styles.field}
							onChange={(e) => onChange(e)}
						/>
						{/* <TextField
							id='date'
							label='Approval date'
							type='date'
							name='approvalDate'
							value={approvalDate}
							onChange={(e) => onChange(e)}
							className={styles.field}
							InputLabelProps={{
								shrink: true,
							}}
						/> */}

						<TextField
							type='text'
							label='Approval Date'
							name='approvalDate'
							value={dayjs(approvalDate).format('DD MMMM YYYY')}
							className={styles.field}
							onChange={(e) => onChange(e)}
							onClick={() => setShowCalendar(true)}
						/>

						{showCalendar === true && (
							<div className='dates_wrapper'>
								<Calendar
									onChange={(e) => {
										setApprovalDate(new Date(e).getTime());
										setShowCalendar(false);
									}}
									value={approvalDate}
									className='new-react-calendar'
									minDate={new Date()}
									showFixedNumberOfWeeks={true}
								/>
							</div>
						)}
						<button
							className='corporationBtn btn btn-primary d-block mr-0 ml-auto'
							onClick={() => handleSave()}
						>
							Save
						</button>
					</div>
				) : null}

				<div className='card_title'>Downpayment schedule</div>
				{/* <div className='downpayments_group'>
					{downpaymentSchedule?.map((item) => {
						{
							console.log(JSON.stringify(downpaymentSchedule));
						}
						return (
							<div className='downpayment_item'>
								<div className='schedule_title'>
									{item.numberString} Installment
								</div>
								<small className='lot_single_sqft'>
									<span className='lot_availability'>
										<FiberManualRecordIcon className='current_payment' />
									</span>
									{item.date}
									<span class='installment_price'>${item.installment}</span>
								</small>
							</div>
						);
					})}
				</div> */}
				<div className='downpayments_group'>
					<div className='downpayment_item'>
						<div className='schedule_title'>First Installment</div>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='current_payment' />
							</span>
							{firstInstallmentDate}
							{console.log('firstInstallment: ' + firstInstallmentDate)}

							<span class='installment_price'>
								${numberWithCommas(firstInstallmentCost)}
							</span>
						</small>
						<br />
						<small
							className='edit_btn'
							onClick={() => {
								setShow(true);
							}}
						>
							Edit
						</small>
					</div>
					<div className='downpayment_item'>
						<div className='schedule_title'>Second Installment</div>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='current_payment' />
							</span>
							{secondInstallmentDate}
							<span class='installment_price'>
								${numberWithCommas(secondInstallmentCost)}
							</span>
						</small>
						<br />
						<small
							className='edit_btn'
							onClick={() => {
								setShow(true);
							}}
						>
							Edit
						</small>
					</div>
					<div className='downpayment_item'>
						<div className='schedule_title'>Third Installment</div>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='current_payment' />
							</span>
							{thirdInstallmentDate}
							<span class='installment_price'>
								${numberWithCommas(thirdInstallmentCost)}
							</span>
							{console.log(thirdInstallmentDate)}
						</small>
						<br />
						<small
							className='edit_btn'
							onClick={() => {
								setShow(true);
							}}
						>
							Edit
						</small>
					</div>
					<div className='downpayment_item'>
						<div className='schedule_title'>Forth Installment</div>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='current_payment' />
							</span>
							{forthInstallmentDate}
							<span class='installment_price'>
								${numberWithCommas(forthInstallmentCost)}
							</span>
						</small>
						<br />
						<small
							className='edit_btn'
							onClick={() => {
								setShow(true);
							}}
						>
							Edit
						</small>
					</div>
					<div className='downpayment_item'>
						<div className='schedule_title'>Fifth Installment</div>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='current_payment' />
							</span>
							{fifthInstallmentDate}
							<span class='installment_price'>
								${numberWithCommas(fifthInstallmentCost)}
							</span>
						</small>
						<br />
						<small
							className='edit_btn'
							onClick={() => {
								setShow(true);
							}}
						>
							Edit
						</small>
					</div>
					<div className='downpayment_item'>
						<div className='schedule_title'>Sixth Installment</div>
						<small className='lot_single_sqft'>
							<span className='lot_availability'>
								<FiberManualRecordIcon className='current_payment' />
							</span>
							{sixthInstallmentDate}
							<span class='installment_price'>
								${numberWithCommas(sixthInstallmentCost)}
							</span>
						</small>
						<br />
						<small
							className='edit_btn'
							onClick={() => {
								setShow(true);
							}}
						>
							Edit
						</small>
					</div>
				</div>

				{show ? (
					<div onClick={closeModalHandler} className='back-drop'></div>
				) : null}
				<Modal
					show={show}
					close={closeModalHandler}
					title='Edit Installments'
					buttonName='Save'
					button={handleSaveInstallment}
				>
					<div className='first_installment row'>
						<div>
							<label className={clsx(styles.field, styles.label)}>
								First Installment Date
							</label>
							<DatePicker
								selected={firstInstallmentDateModal}
								id='date'
								placeholderText='First Installment Date'
								minDate={Date.now()}
								onChange={(date) => setFirstInstallmentDateModal(date)}
								className={clsx(
									styles.field,
									styles.datePicker,
									styles.installmentDate
								)}
								showTimeSelect={false}
							/>
						</div>
						<TextField
							type='number'
							label='First Installment Cost'
							name='firstInstallmentCostModal'
							defaultValue={firstInstallmentCost}
							value={firstInstallmentCostModal}
							className={styles.field}
							onChange={({ target }) =>
								setFirstInstallmentCostModal(target.value)
							}
						/>
					</div>
					<div className='second_installment row'>
						<div>
							<label className={clsx(styles.field, styles.label)}>
								Second Installment Date
							</label>
							<DatePicker
								selected={secondInstallmentDateModal}
								id='date'
								placeholderText='Second Installment Date'
								minDate={Date.now()}
								onChange={(date) => setSecondInstallmentDateModal(date)}
								className={clsx(
									styles.field,
									styles.datePicker,
									styles.installmentDate
								)}
								showTimeSelect={false}
							/>
						</div>
						<TextField
							type='number'
							label='Second Installment Cost'
							name='secondInstallmentCostModal'
							value={secondInstallmentCostModal}
							className={styles.field}
							onChange={({ target }) =>
								setSecondInstallmentCostModal(target.value)
							}
						/>
					</div>
					<div className='third_installment row'>
						<div>
							<label className={clsx(styles.field, styles.label)}>
								Third Installment Date
							</label>
							<DatePicker
								selected={thirdInstallmentDateModal}
								id='date'
								placeholderText='Third Installment Date'
								minDate={Date.now()}
								onChange={(date) => setThirdInstallmentDateModal(date)}
								className={clsx(
									styles.field,
									styles.datePicker,
									styles.installmentDate
								)}
								showTimeSelect={false}
							/>
						</div>
						<TextField
							type='number'
							label='Third Installment Cost'
							name='thirdInstallmentCostModal'
							value={thirdInstallmentCostModal}
							className={styles.field}
							onChange={({ target }) =>
								setThirdInstallmentCostModal(target.value)
							}
						/>
					</div>
				</Modal>
			</div>
		</div>
	);
}

export default Finances;
